import { motion } from "framer-motion";

export default function CTA() {
    return (
        <section className="relative py-32 px-6 lg:px-8 overflow-hidden">
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-accent/[0.04] blur-[120px]" />
            </div>

            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7 }}
                className="relative mx-auto max-w-2xl text-center"
            >
                <h2 className="font-syne text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary leading-tight">
                    Ready to move faster?
                </h2>
                <p className="mt-6 font-outfit text-base sm:text-lg text-text-secondary max-w-lg mx-auto leading-relaxed">
                    Book a free discovery call. No pitch, just honest advice on whether we're the right fit.
                </p>
                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <a
                        href="https://calendly.com/bigweblabs/big-web-labs"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group relative inline-flex items-center gap-2 px-8 py-4 rounded-full bg-accent text-void font-outfit font-semibold text-sm transition-all duration-300 hover:shadow-[0_0_40px_rgba(34,211,238,0.3)] hover:scale-[1.02]"
                    >
                        Book a Free Call
                        <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                        </svg>
                    </a>
                    <a
                        href="/contact"
                        className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-border-medium text-text-secondary font-outfit font-medium text-sm hover:text-text-primary hover:border-text-muted transition-all duration-300"
                    >
                        Send a Message
                    </a>
                </div>
            </motion.div>
        </section>
    );
}
